export default "__VITE_ASSET__046cf352__"